export const PREVIEW_VIDEO_URL =
  'https://videos.covideo.com/videos/179960_54188_nkosouj4iyh1747400023834.mp4';
export const PREVIEW_VIDEO_THUMBNAIL =
  'https://images.covideo.com/thumbnails/179960_54188_nkosouj4iyh1747400023834_0001.png';
